var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeHasReferredOutline = function SvgCassiopeiaBadgeHasReferredOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.39,
    height: 49.288,
    viewBox: "0 0 6.453 13.041",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.85-13.447a1.725 1.725 0 0 0-1.725 1.724 1.725 1.725 0 0 0 .844 1.483v4.035a1.725 1.725 0 0 0-.844 1.482 1.725 1.725 0 0 0 .844 1.483V.602c-2.7.236-5.109 1.456-6.897 3.287L.56 11.412l6.742 5.78a1.675 1.675 0 0 1 .306 2.195l-5.14 7.773 4.646 7.744c7.077-3.94 15.209-12.577 16.535-20.824.19-.805.3-1.64.3-2.502C23.945 5.76 19.44.996 13.73.586V-3.24a1.725 1.725 0 0 0 .844-1.483 1.725 1.725 0 0 0-.844-1.482v-4.035a1.725 1.725 0 0 0 .844-1.483 1.725 1.725 0 0 0-1.724-1.724z",
    style: {
      fill: "#fff",
      fillOpacity: 0.501961,
      stroke: "#000",
      strokeWidth: 1.00157,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "3.00472,1.00157",
      strokeDashoffset: 1.4022,
      strokeOpacity: 0.501961
    },
    transform: "matrix(.26458 0 0 .26458 -.015 3.69)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeHasReferredOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-has-referred-outline.e7dec9155e59f4e99c7cf3b4280108e2.svg";